export const GET_COSTS_REQUEST = 'wholesale/GET_COSTS_REQUEST'
export const GET_COSTS_SUCCESS = 'wholesale/GET_COSTS_SUCCESS'
export const GET_COSTS_FAILURE = 'wholesale/GET_COSTS_FAILURE'

export const GET_WEATHER_SUCCESS = 'wholesale/GET_WEATHER_SUCCESS'
export const GET_WEATHER_FAILURE = 'wholesale/GET_WEATHER_FAILURE'
